import Vue from 'vue';

Vue.component('ShareIcon', {
  template: `
    <span class="icon-share">
      <?xml version="1.0" encoding="utf-8"?>
      <!-- Generator: Adobe Illustrator 17.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
      <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23.146 21.367" width="23px" height="22px" x="0px" y="0px">
        <g id="Share_icon" transform="translate(-1060.025 -107.976)">
          <g id="icon-share">
            <path id="Share_element_1" class="cls-1" d="M0,0A3.858,3.858,0,0,1-3.858,3.858,3.858,3.858,0,0,1-7.716,0,3.858,3.858,0,0,1-3.858-3.858,3.858,3.858,0,0,1,0,0" transform="translate(1067.741 118.956)"/>
            <path id="Share_element_2" class="cls-1" d="M0,0A3.858,3.858,0,0,1-3.858,3.858,3.858,3.858,0,0,1-7.716,0,3.857,3.857,0,0,1-3.858-3.857,3.857,3.857,0,0,1,0,0" transform="translate(1083.172 125.484)"/>
            <path id="Share_element_3" class="cls-1" d="M0,0A3.857,3.857,0,0,1-3.858,3.857,3.857,3.857,0,0,1-7.716,0,3.858,3.858,0,0,1-3.858-3.858,3.858,3.858,0,0,1,0,0" transform="translate(1083.172 111.834)"/>
            <path id="Share_element_4" class="cls-2" d="M0,0,13.363-7.03M.018,1.622,13.386,8.654" transform="translate(1067.322 118.113)"/>
          </g>
        </g>
      </svg>
    </span>
  `,
});



// WEBPACK FOOTER //
// ./components/icons/share.js